import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimezoneOffsetInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timezone = new Date().getTimezoneOffset();

    const clonedRequest = req.clone({
      headers: req.headers.set('X-Timezone-Offset', `${timezone}`),
    });

    return next.handle(clonedRequest);
    // return next.handle(req);
  }
}
